/**
 * 2024/1/16 14:35
 * author: DLH
 * email: denglihua
 */
import addTypeView from './src/addTypeView.vue';

/* istanbul ignore next */
addTypeView.install = function(Vue) {
    Vue.component(addTypeView.name, addTypeView);
};

export default addTypeView;